import { CircularProgress, Tab, Tabs, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import { TServicesPresetFilterValue } from "../../hooks/useServicesPageFilters";

const StyledTabs = styled(Tabs)`
  .MuiTab-root {
    text-transform: none;
    color: ${cuideoTheme.palette.primary.main};

    .CMuiTabLabelNumberBackground {
      background-color: rgba(0, 72, 120, 0.15);
    }

    .MuiCircularProgress-colorPrimary {
      position: absolute;
      top: 20%;
      left: 20%;
    }

    &.Mui-selected {
      background-color: ${cuideoTheme.palette.primary.main};
      color: ${cuideoTheme.palette.common.white};

      .CMuiTabLabelNumberBackground {
        background-color: rgba(255, 255, 255, 0.1);
      }

      .MuiCircularProgress-colorPrimary {
        color: ${cuideoTheme.palette.common.white};
      }
    }
  }

  .MuiTabs-indicator {
    display: none;
  }
`;

const StyledLabelWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const StyledLabel = styled(Typography)`
  font-size: 1rem;
  font-weight: 700;
`;

const StyledLabelInfoWrapper = styled.span`
  margin-left: 0.5rem;
  position: relative;
  width: 1.25rem;
  height: 1.3125rem;
  text-align: center;
`;

const StyledLabelInfoBackground = styled.span`
  display: block;
  position: absolute;
  border-radius: 50%;
  top: -0.25rem;
  left: -0.1875rem;
  height: 1.825rem;
  width: 1.825rem;
`;

const StyledLabelNumber = styled(Typography)`
  font-size: 0.875rem;
  letter-spacing: -0.0625rem;
  font-weight: 600;
`;

interface IServiceQuickFilterData {
  isLoading: boolean;
  totalServices: number;
}

interface IServicesQuickFiltersTabs {
  value: TServicesPresetFilterValue;
  onNewServicesClick: () => void;
  onValuatedClick: () => void;
  // onFollowUpClick: () => void;
  newServices: IServiceQuickFilterData;
  valuatedServices: IServiceQuickFilterData;
  // followUpServices: IServiceQuickFilterData;
}

const ServicesQuickFiltersTabs = (props: IServicesQuickFiltersTabs) => {
  const {
    value,
    onNewServicesClick,
    onValuatedClick,
    // onFollowUpClick,
    newServices,
    valuatedServices,
    // followUpServices,
  } = props;

  const handleTabsChange = (
    event: React.ChangeEvent<{}>,
    newValue: TServicesPresetFilterValue
  ) => {
    switch (newValue) {
      case "new":
        onNewServicesClick();
        break;
      case "valuated":
        onValuatedClick();
        break;
      // case "follow-up":
      //   onFollowUpClick();
      //   break;
    }
  };

  return (
    <StyledTabs
      variant="fullWidth"
      textColor="primary"
      value={value}
      onChange={handleTabsChange}
    >
      <Tab
        label={
          <StyledLabelWrapper>
            <StyledLabel>
              <FormattedMessage
                id="ServicesTabs.Servicios Nuevos"
                defaultMessage="Servicios Nuevos"
              />
            </StyledLabel>
            <StyledLabelInfoWrapper>
              <StyledLabelInfoBackground className="CMuiTabLabelNumberBackground" />
              {newServices.isLoading ? (
                <CircularProgress size={12} />
              ) : (
                <StyledLabelNumber className="CMuiTabLabelNumber">
                  {newServices.totalServices > 999
                    ? "+999"
                    : newServices.totalServices}
                </StyledLabelNumber>
              )}
            </StyledLabelInfoWrapper>
          </StyledLabelWrapper>
        }
        value="new"
      />
      <Tab
        label={
          <StyledLabelWrapper>
            <StyledLabel>
              <FormattedMessage
                id="ServicesTabs.Servicios Valorados"
                defaultMessage="Servicios Valorados"
              />
            </StyledLabel>
            <StyledLabelInfoWrapper>
              <StyledLabelInfoBackground className="CMuiTabLabelNumberBackground" />
              {valuatedServices.isLoading ? (
                <CircularProgress size={14} />
              ) : (
                <StyledLabelNumber className="CMuiTabLabelNumber">
                  {valuatedServices.totalServices > 999
                    ? "+999"
                    : valuatedServices.totalServices}
                </StyledLabelNumber>
              )}
            </StyledLabelInfoWrapper>
          </StyledLabelWrapper>
        }
        value="valuated"
      />
    </StyledTabs>
  );
};

export default ServicesQuickFiltersTabs;
